'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary } from 'react-error-boundary';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { useCallback, type ReactElement, type ReactNode } from 'react';
import { logAndReportError } from 'shared/errorReporter';
import CopilotDrawerErrorState from './CopilotDrawerErrorState';
interface CopilotDrawerErrorBoundaryProps {
  children: ReactNode;
}
type OnError = (error: Error) => void;

/**
 * Isolates Copilot drawer content failures so API hook/render errors display
 * an inline error state with recovery actions instead of breaking the dashboard frame.
 *
 * Intentionally has no visibility-based resetKeys: the drawer stays mounted while
 * closed, and remounting a crashing tree on open/close would rethrow, re-report,
 * and reset QueryErrorResetBoundary while the UI is hidden. Recovery is explicit
 * via CopilotDrawerErrorState ("Try again" / "Start new chat").
 */
const CopilotDrawerErrorBoundary = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  const handleError = _temp;
  let t1;
  if ($[0] !== children) {
    t1 = <QueryErrorResetBoundary>{t2 => {
        const {
          reset
        } = t2;
        return <ErrorBoundary onError={handleError} onReset={reset} fallbackRender={_temp2}>{children}</ErrorBoundary>;
      }}</QueryErrorResetBoundary>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default CopilotDrawerErrorBoundary;
function _temp(error) {
  logAndReportError(error);
}
function _temp2(t0) {
  const {
    resetErrorBoundary
  } = t0;
  return <CopilotDrawerErrorState onRetry={resetErrorBoundary} />;
}